import { jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { s as styles } from "../../../../chunks/Modal.module-DVI2zRnB.js";
const ModalBackdrop = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsx("div", { className: clsx(styles.modalBackdrop, className), ...props, children });
};
export {
  ModalBackdrop
};
